import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const updateHrisIntegrationResponse = (update: HrisIntegrationResponseUpdateRequest) =>
  createGenericDispatcher<HrisIntegrationResponse>({
    name: 'UPDATE_HRIS_INTEGRATION_RESPONSE',
    loadFunction: () =>
      Api.post(`/hris-integration-response/${update.hrisIntegrationResponseId}`, {
        body: JSON.stringify({ ...update }),
      }),
    args: { update },
  });
